import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "arrow"]

  connect() {
    this.element.addEventListener("mouseenter", () => {
      this.show()
      this.rotateArrow()
    })
    this.element.addEventListener("mouseleave", () => {
      this.hide()
      this.resetArrow()
    })
  }

  show() {
    this.menuTarget.classList.remove("hidden")
  }

  hide() {
    this.menuTarget.classList.add("hidden")
  }

  rotateArrow() {
    if (this.hasArrowTarget) {
      this.arrowTarget.classList.add("rotate-180")
    }
  }

  resetArrow() {
    if (this.hasArrowTarget) {
      this.arrowTarget.classList.remove("rotate-180")
    }
  }
} 